export default __webpack_public_path__ + "static/media/icon-toll.8e02060a.svg";